<template>
    <div class="in-place-editor"
         title="Click to edit"
         tabindex="1"
         @focus.stop="setEditable(true)"
         @click.stop="setEditable(true)"
         :class="{'is-editing': editable, 'has-content': modelValue && modelValue.length}">
        <div @blur="update"
             class="editor"
             ref="editor"
             @keydown="editingContent"
             :contenteditable="editable" v-html="filterForPreviewing(value)"></div>
        <div class="placeholder"
             v-html="placeholder"/>
    </div>
</template>

<script>

import utils from "@/mixins/utils";

export default {
    name: "InPlaceHtmlEditor",
    emits: ['update:modelValue', 'change'],
    mixins: [utils],

    props: {
        modelValue: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Click here to edit...'
        },
        readonly: {
            type: String,
            default: 'Click here to edit...'
        }
    },

    data() {
        return {
            value: '',
            editable: false,
        };
    },

    methods: {

        update() {
            this.value = this.filterForStoring(this.$refs.editor.innerHTML);
            this.$emit('update:modelValue', this.value);
            this.$emit('change', this.value);
            this.setEditable(false);
            this.$forceUpdate();
        },

        setEditable(editable) {
            this.editable = editable;
            if (this.editable) {
                this.$nextTick(() => this.$refs.editor.focus());
            }
        },

        editingContent(ev) {
            if (ev.key === 'Enter') {
                if (ev.ctrlKey) {
                    this.update();
                } else {
                    document.execCommand('insertLineBreak');
                    ev.preventDefault();
                }
            }
        },

        filterForStoring(html) {
            const tmp = document.createElement("div");
            tmp.innerHTML = html
                .replace("<br>", "\n")
                .replace("<br/>", "\n");
            return tmp.textContent || tmp.innerText;
        },

        filterForPreviewing(text) {
            return this.utils.nl2br(text);
        },

    },

    mounted() {
        this.value = this.modelValue;
    }

}
</script>

<style lang="scss" scoped>

.in-place-editor {
    word-break: break-word;
    &:hover, &:focus {
        cursor: text;
        background: rgba(white, .3);
        box-shadow: rgba(black, .2) 0 2px 3px inset;
    }

    &.is-editing {
        .editor {
            padding: 0 1px;
        }
    }

    .editor {
        display: none;
    }

    .placeholder {
        display: block;
        text-align: center;
    }

    &.has-content, &.is-editing {
        .editor {
            display: block;
            text-align: center;
        }

        .placeholder {
            display: none;
        }
    }
}

.editor {
    min-height: 2rem;
}
</style>
